import Chatbot from "react-chatbot-kit";
import 'react-chatbot-kit/build/main.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faXmark } from '@fortawesome/free-solid-svg-icons';
import React, { useState } from 'react'
import config from "./config";
import MessageParser from "./MessageParser";
import ActionProvider from "./ActionProvider";

function MyChatbot() {

    const [isOpen, setIsOpen] = useState(false);

    const toggleChatbot = () => {
        setIsOpen(prev => !prev);
    }

  return (
    <div style={{ position: 'fixed', bottom: '50px', right: '20px', zIndex: "1000", display: "flex", gap: "5px" }}>
      <div
        onClick={toggleChatbot}
        style={{
          width: (isOpen) ? '30px' : '50px',
          height: (isOpen) ? '30px' : '50px',
          borderRadius: '50%',
          backgroundColor: (isOpen) ? '#FF0000' :'#ffa502',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          float: 'right',
          cursor: 'pointer',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          transition: 'transform 0.3s ease'
        }}
        onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.15)'; 
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)'; 
        }}
      >
        {
            (isOpen) ? <FontAwesomeIcon icon={faXmark} /> :
            <FontAwesomeIcon icon={faComment} size="lg" />
        }
        
      </div>
      {isOpen && (
        <Chatbot
          config={config}
          messageParser={MessageParser}
          actionProvider={ActionProvider}
          style={{ marginTop: '10px' }} 
        />
      )}
    </div>
  )
}

export default MyChatbot
